import { Button, Typography } from '@mui/material'
import { DoneOutline } from '@mui/icons-material'
import { Grid } from '../../../../components/UniversalComponents'
import { useAuth } from '../../../AuthenticationContext'
import BoatConfigurationForm from '../../../../components/Admin/Boats/BoatConfiguration/BoatConfigForms/BoatConfigurationForm'

const Step4Boat = ({ setNextStep, permissionsCheck, endQuickStart }) => {
    const currentUser = useAuth()
    const { userProfile } = currentUser.auth
    const { superAdmin } = userProfile
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography
                    align="center"
                    variant="h5"
                    color="warning"
                    sx={{ margin: 2 }}
                >
                    If you already have a configured boat you can:
                    {
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={endQuickStart}
                            sx={{ width: 200, marginLeft: 5 }}
                            endIcon={<DoneOutline />}
                        >
                            End Quick Start
                        </Button>
                    }
                </Typography>
            </Grid>
            <Grid item xs={12}>
                <BoatConfigurationForm
                    row={{}}
                    formDescription="Use this form to add a new Signal Profile within Osmosis Telematics Platform"
                    onClose={endQuickStart}
                    saveCache={() => {}}
                    permissionCheck={permissionsCheck}
                    superAdmin={superAdmin}
                />
            </Grid>
        </Grid>
    )
}

export default Step4Boat
